import logoFTD from './logo-FTD.svg';
import logoMarista from './logo-marista.png';
import logoCampanha from './logo-df-amarelo-com.png';
import logoFacaBonito from './logo-faca-bonito.png';

export default {
  logoMarista,
  logoFTD,
  logoCampanha,
  logoFacaBonito
};
